var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.baseErrorClass]},[(
      typeof _vm.validate.required !== 'undefined' &&
      !_vm.validate.required &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.label))+" is required")]):(
      typeof _vm.validate.requiredIf !== 'undefined' &&
      !_vm.validate.requiredIf &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.label))+" is required")]):(
      typeof _vm.validate.email !== 'undefined' &&
      (!_vm.validate.email || !_vm.validate.isValidEmail) &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v("Invalid "+_vm._s(_vm._f("capitalize")(_vm.label))+" ID")]):(
      typeof _vm.validate.isValidPassword !== 'undefined' &&
      !_vm.validate.isValidPassword &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Please create password as per criteria mentioned below ")]):(
      typeof _vm.validate.isValidImage !== 'undefined' && !_vm.validate.isValidImage
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Please upload profile picture as per criteria mentioned below ")]):(
      typeof _vm.validate.sameAsPassword !== 'undefined' &&
      !_vm.validate.sameAsPassword &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Password does not match, please try again ")]):(
      typeof _vm.validate.isValidPhoneNumber !== 'undefined' &&
      !_vm.validate.isValidPhoneNumber &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Invalid "+_vm._s(_vm._f("capitalize")(_vm.label))+" ")]):(
      typeof _vm.validate.numeric !== 'undefined' &&
      !_vm.validate.numeric &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Invalid "+_vm._s(_vm._f("capitalize")(_vm.label))+" ")]):(
      ((typeof _vm.validate.minLength !== 'undefined' && !_vm.validate.minLength) ||
        (typeof _vm.validate.maxLength !== 'undefined' && !_vm.validate.maxLength)) &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.label))+" "),(typeof _vm.validate.$params.maxLength === 'undefined')?_c('span',[_vm._v(" must contain at least "+_vm._s(_vm.validate.$params.minLength.min))]):(typeof _vm.validate.$params.minLength === 'undefined')?_c('span',[_vm._v(" cannot exceed "+_vm._s(_vm.validate.$params.maxLength.max)+" ")]):_c('span',[_vm._v("must be between "+_vm._s(_vm.validate.$params.minLength.min)+" and "+_vm._s(_vm.validate.$params.maxLength.max))]),_vm._v(" characters ")]):(
      typeof _vm.validate.alphaNum !== 'undefined' &&
      !_vm.validate.alphaNum &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Only alphabets and numbers are allowed ")]):(
      typeof _vm.validate.isValidVideoLink !== 'undefined' &&
      !_vm.validate.isValidVideoLink &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Invalid Video Link ")]):(
      typeof _vm.validate.isValidRange !== 'undefined' &&
      !_vm.validate.isValidRange &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Invalid "+_vm._s(_vm._f("capitalize")(_vm.label))+" ")]):(
      typeof _vm.validate.url !== 'undefined' && !_vm.validate.url && _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" Invalid "+_vm._s(_vm._f("capitalize")(_vm.label))+" ")]):(
      typeof _vm.validate.minValue !== 'undefined' &&
      !_vm.validate.minValue &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.label))+" must be greater than or equal to "+_vm._s(_vm.validate.$params.minValue.min)+" ")]):(
      typeof _vm.validate.maxValue !== 'undefined' &&
      !_vm.validate.maxValue &&
      _vm.validate.$error
    )?_c('small',{staticClass:"is-invalid text-danger"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.label))+" must be less than or equal to "+_vm._s(_vm.validate.$params.maxValue.max)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }